<div [ngClass]="'header-content-'+ (isDesigner ? 'edit' : 'preview')" [attr.tabindex]="isDesigner ? '0' : '-1'"
    (click)="isDesigner ? onShowConfiguration($event) : null" (keydown)="isDesigner ? onHandleKey($event) : null">

    <div class="flex align-items-center font-principal font-23 title-blue uppercase">
        {{title}}
    </div>
</div>
